import classNames from 'classnames';
import React from 'react';

import { LinkButton } from '@eika/button';
import { Icon, IconTypes } from '@eika/icon';
import { Loader } from '@eika/loader';

import { Attachment, AttachmentStatus } from './file-uploader-types';

interface FileUploadRowProps {
    file: Attachment;
    onDelete: () => void;
    status: AttachmentStatus;
}

const FileUploaderAttachmentRow = ({ file, onDelete, status }: FileUploadRowProps) => (
    <li
        className={classNames('file-uploader-list-element', {
            'file-uploader-list-element--invalid':
                status === AttachmentStatus.Error || status === AttachmentStatus.ErrorTotalFileSize,
        })}
    >
        <Icon type={IconTypes.DOKUMENT_24} />
        <div className="typography-subtitle file-uploader-list-element-file-name">{file.file.name}</div>
        {status === AttachmentStatus.Uploading && <Loader className="sgw-file-uploader--spinner" mini />}
        {status === AttachmentStatus.Ok && <LinkButton onClick={onDelete}>Slett</LinkButton>}
    </li>
);

export default FileUploaderAttachmentRow;
